import { render, staticRenderFns } from "./ImprimirTicket.vue?vue&type=template&id=7035fc4a"
import script from "./ImprimirTicket.vue?vue&type=script&lang=js"
export * from "./ImprimirTicket.vue?vue&type=script&lang=js"
import style0 from "./ImprimirTicket.vue?vue&type=style&index=0&id=7035fc4a&prod&lang=css"
import style1 from "./ImprimirTicket.vue?vue&type=style&index=1&id=7035fc4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports